var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeePortalLogoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199.583,
    height: 13.138,
    viewBox: "0 0 199.583 13.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_975",
    "data-name": "Rectangle 975",
    width: 199.583,
    height: 13.138,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    width: 5.866,
    height: 5.866,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1593",
    "data-name": "Group 1593",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1592",
    "data-name": "Group 1592",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1591",
    "data-name": "Group 1591",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M0,1.2V13.778H6.974V11.666H2.45V8.236H6.786V6.125H2.45V3.316H6.974V1.2Z",
    transform: "translate(0 -0.922)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M53.111,1.205h1.772L58.219,9.2l3.487-7.992h1.772l2.111,12.573H63.1L61.97,6.031,58.6,13.778h-.829L54.543,6.031l-1.282,7.747H50.773Z",
    transform: "translate(-38.86 -0.922)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M140.714,1.205a4.506,4.506,0,0,1,3.317.962A4,4,0,0,1,145.313,5.2a4.041,4.041,0,0,1-1.037,2.809,4.311,4.311,0,0,1-3.186,1.112h-1.584v4.656h-2.45V1.205Zm-1.206,5.806h1a2.508,2.508,0,0,0,1.6-.4,1.876,1.876,0,0,0,.679-1.47,1.732,1.732,0,0,0-.7-1.433,2.951,2.951,0,0,0-1.734-.4h-.848Z",
    transform: "translate(-104.899 -0.922)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M196.066,1.205V11.667h3.883v2.111h-6.334V1.205Z",
    transform: "translate(-148.187 -0.922)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M250.661,6.579a6.712,6.712,0,0,1-13.421,0,6.712,6.712,0,0,1,13.421,0m-2.526,0a4.188,4.188,0,1,0-8.369,0,4.187,4.187,0,1,0,8.369,0",
    transform: "translate(-181.576 0)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M313.3,8.029l-4.317-6.824h2.9l2.7,4.373,2.7-4.373h2.9l-4.43,6.824v5.749H313.3Z",
    transform: "translate(-236.486 -0.922)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M383.281,3.316h-4.524V6.124h4.335V8.236h-4.335v3.431h4.524v2.111h-6.974V1.2h6.974Z",
    transform: "translate(-288.013 -0.922)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M436.785,3.316h-4.524V6.124H436.6V8.236h-4.335v3.431h4.524v2.111h-6.974V1.2h6.974Z",
    transform: "translate(-328.964 -0.922)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M519.35,1.205a4.506,4.506,0,0,1,3.317.962A4,4,0,0,1,523.949,5.2a4.042,4.042,0,0,1-1.037,2.809,4.31,4.31,0,0,1-3.186,1.112h-1.583v4.656h-2.451V1.205Zm-1.206,5.806h1a2.507,2.507,0,0,0,1.6-.4,1.876,1.876,0,0,0,.679-1.47,1.732,1.732,0,0,0-.7-1.433,2.952,2.952,0,0,0-1.734-.4h-.848Z",
    transform: "translate(-394.695 -0.922)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M653.817,1.205a4.624,4.624,0,0,1,3.2.943,3.572,3.572,0,0,1,1.244,2.828,3.434,3.434,0,0,1-1.47,2.959,3.483,3.483,0,0,1-1.376.547l3.921,5.3h-3.054l-3.355-5.052h-.3v5.052h-2.451V1.205ZM652.63,6.992h.7c.471,0,2.413-.057,2.413-1.9,0-1.866-1.923-1.885-2.375-1.885h-.735Z",
    transform: "translate(-497.627 -0.922)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M709.605,3.316V13.777h-2.451V3.316h-2.827V1.2h8.105V3.316Z",
    transform: "translate(-539.07 -0.922)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M758.881,11.139h-5.071L752.7,13.778h-2.658l5.41-12.573h1.923l5.259,12.573h-2.639Zm-.716-2-1.791-4.524-1.791,4.524Z",
    transform: "translate(-574.058 -0.922)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M826.082,1.205V11.667h3.883v2.111h-6.333V1.205Z",
    transform: "translate(-630.382 -0.922)",
    fill: "#2ec193"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M577.527,13.532a6.452,6.452,0,1,1,6.452-6.452,6.46,6.46,0,0,1-6.452,6.452m0-10.558a4.106,4.106,0,1,0,4.106,4.106,4.111,4.111,0,0,0-4.106-4.106",
    transform: "translate(-437.083 -0.48)",
    fill: "#2cfcbd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1590",
    "data-name": "Group 1590",
    transform: "translate(137.511 3.667)",
    opacity: 0.504
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1589",
    "data-name": "Group 1589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1588",
    "data-name": "Group 1588",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M589.008,21.493a2.933,2.933,0,1,1,2.933-2.933,2.936,2.936,0,0,1-2.933,2.933m0-4.693a1.76,1.76,0,1,0,1.76,1.76,1.762,1.762,0,0,0-1.76-1.76",
    transform: "translate(-586.075 -15.627)",
    fill: "#2cfcbd"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeePortalLogoGreen);
export default __webpack_public_path__ + "static/media/EmployeePortalLogoGreen.6771dc892bd25c9f43c7d73ab24fe5d1.svg";
export { ForwardRef as ReactComponent };